import React from 'react';
import { type ButtonProps, useDisclosure } from '@chakra-ui/react';

import { Button } from '@/components';
import LogoutConfirmModal from '@/components/ui/Header/LogoutModal';
import { useTranslation } from '@/hooks';
import SignOutOfAccountIcon from '@/svgs/dashboard/drawer/logOut.svg';

type LogoutButtonProps = { onConfirm?: () => void } & ButtonProps;

const LogoutButton: React.FC<LogoutButtonProps> = ({
  onConfirm,
  ...buttonProps
}) => {
  const { t } = useTranslation('components.header.logoutModal');
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button
        colorScheme="white"
        height="27px"
        padding="0"
        textColor="text"
        w="100%"
        onClick={onOpen}
        fontSize="sm"
        justifyContent={'flex-start'}
        gap={8}
        {...buttonProps}
      >
        <SignOutOfAccountIcon strokeWidth={'2'} stroke={'text'} />
        {t('signOut')}
      </Button>
      <LogoutConfirmModal
        isOpen={isOpen}
        onClose={onClose}
        onConfirm={onConfirm}
      />
    </>
  );
};

export default LogoutButton;
